<template>
  <div>
    <el-table
      :data="rows"
      @sort-change="doChangeSort"
      ref="table"
      row-key="id"
      v-loading="loading"
    >
      <!-- <el-table-column type="selection" width="55"></el-table-column> -->

      <el-table-column v-if="hasPermissionToAuditLogs" :label="fields.id.label"  :prop="fields.id.name" >
        <template slot-scope="scope">{{ presenter(scope.row, 'id') }}</template>
      </el-table-column>


      <el-table-column
        :resizable="false"
        :label="fields.name.label"
        :prop="fields.name.name"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'name') }}</template>
      </el-table-column>

      <el-table-column
        v-if="hasPermissionToAuditLogs"
        :label="fields.createdAt.label"
        :prop="fields.createdAt.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'createdAt') }}</template>
      </el-table-column>

      <!-- <el-table-column v-if="!isDisabledActionsColumn" :fixed="isMobile? undefined : 'right'" align="center" width="180">
        <template slot-scope="scope">
          <div class="table-actions">
            <router-link :to="`/family/${scope.row.id}/${subpropertyId}`">
              <el-button type="text">
                <app-i18n code="common.view"></app-i18n>
              </el-button>
            </router-link>

            <router-link :to="`/family/${scope.row.id}/edit/${subpropertyId}`" v-if="hasPermissionToEdit">
              <el-button
                icon="icon-pen"
                circle
              />
            </router-link>

           <el-button
              :disabled="destroyLoading"
              @click="doDestroyWithConfirm(scope.row.id)"
              circle
              v-if="hasPermissionToDestroy"
              icon="icon-trash"
            />
          </div>
        </template>
      </el-table-column> -->
    </el-table>

    <div class="el-pagination-wrapper">
      <el-pagination
        :current-page="pagination.currentPage || 1"
        :disabled="loading"
        :layout="paginationLayout"
        :total="count"
        @current-change="doChangePaginationCurrentPage"
        @size-change="doChangePaginationPageSize"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { AuditLogPermissions } from '@modules/audit-log/audit-log-permissions';
import { FamilyModel } from '@modules/family/family-model';
import { mapGetters, mapActions } from 'vuex';
import { FamilyPermissions } from '@modules/family/family-permissions';
import { i18n } from '@shared/i18n';

const { fields } = FamilyModel;
const IS_DISABLED_ACTIONS_COLUMN = true;

export default {
  name: 'app-family-list-table',

  props: {
    subpropertyId: {
      type: String,
      required: true
    }
  },

  mounted() {
    this.doMountTable(this.$refs.table);
  },

  computed: {
    ...mapGetters({
      rows: 'family/list/rows',
      count: 'family/list/count',
      loading: 'family/list/loading',
      pagination: 'family/list/pagination',
      isMobile: 'layout/isMobile',
      currentUser: 'auth/currentUser',
      destroyLoading: 'family/destroy/loading',
      paginationLayout: 'layout/paginationLayout',
    }),

    hasPermissionToAuditLogs() {
      return new AuditLogPermissions(this.currentUser).read;
    },

    hasPermissionToEdit() {
      return new FamilyPermissions(this.currentUser).edit;
    },

    hasPermissionToDestroy() {
      return new FamilyPermissions(this.currentUser).destroy;
    },

    fields() {
      return fields;
    },

    isDisabledActionsColumn() {
      return IS_DISABLED_ACTIONS_COLUMN;
    }
  },

  methods: {
    ...mapActions({
      doChangeSort: 'family/list/doChangeSort',
      doChangePaginationCurrentPage:
        'family/list/doChangePaginationCurrentPage',
      doChangePaginationPageSize:
        'family/list/doChangePaginationPageSize',
      doMountTable: 'family/list/doMountTable',
      doDestroy: 'family/destroy/doDestroy',
    }),

    presenter(row, fieldName) {
      return FamilyModel.presenter(row, fieldName);
    },

    async doDestroyWithConfirm(id) {
      try {
        await this.$confirm(
          i18n('common.areYouSure'),
          i18n('common.confirm'),
          {
            confirmButtonText: i18n('common.yes'),
            cancelButtonText: i18n('common.no'),
            type: 'warning',
          },
        );

        return this.doDestroy({id, subpropertyId: this.subpropertyId});
      } catch (error) {
        // no
      }
    },
  },
};
</script>

<style>
</style>
